<template>
    <div class="staff">
<!--      <el-card>-->
<!--        <el-breadcrumb separator="/">-->
<!--          <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--          <el-breadcrumb-item>大客户管理</el-breadcrumb-item>-->
<!--          <el-breadcrumb-item>公司管理</el-breadcrumb-item>-->
<!--        </el-breadcrumb>-->
<!--      </el-card>-->
      <main class="content">
        <el-card>
          <el-form :inline="true" :model="searchForm"  size="mini">
            <el-form-item label="客户名称">
              <el-input v-model="searchForm.companyName" placeholder="客户名称" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
            </el-form-item>
          </el-form>
          <div ref="tablePosition"></div>
          <el-table
            stripe size="mini"
            :height="tableConfig.height"
            :data="tableData"
            v-loading="loading"
            style="width: 100%">
            <el-table-column
              prop="companyName"
              label="客户名称">
            </el-table-column>
            <el-table-column
              width="120"
              prop="fillDemandMonth"
              label="需求所属月份">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.fillDemandMonth ? 'primary' : 'info'"
                  disable-transitions>{{scope.row.fillDemandMonth ? "需要" : "不需要" }}</el-tag>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="distribution"
              label="配送目的地址">
              <template slot-scope="scope">
                {{scope.row.distribution === 1 ? '平台仓储' : '客户填写地址'}}
              </template>
            </el-table-column>
            <el-table-column
              prop="internalReview"
              label="下单前客户内部审核">
              <template slot-scope="scope">
                {{scope.row.internalReview ? '需要' : '不需要'}}
              </template>
            </el-table-column> -->
            <el-table-column
              width="80"
              prop="valid"
              label="状态">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.valid ? 'primary' : 'info'"
                  disable-transitions>{{scope.row.valid ? "有效" : "无效" }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="right">
              <template slot="header">
                <el-button type="primary" @click="showCreateDialog" size="mini">添加</el-button>
              </template>
              <template slot-scope="scope">
                <el-button type="text"
                  size="mini"
                  @click="handleEdit(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;padding-top: 20px">
            <el-pagination
                background
                layout="sizes,prev, pager, next"
                :total="total"
                :page-sizes="[10, 20, 50, 100]"
                v-if="total>0"
                :page-size="pageSize"
                @size-change="handleSizeChange"
                @current-change="onPageChange"
                :current-page="currentPage"
                @prev-click="onPageChange"
                @next-click="onPageChange">
            </el-pagination>
          </div>
        </el-card>
      </main>
      <el-dialog title="添加VIP客户公司" :visible.sync="createDialogVisible" width="1200px" :close-on-click-modal="false">
        <el-form ref="createForm" :model="createForm" :rules="rules" size="mini" label-width="130px">
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item prop="companyId">
                <template slot="label">
                    <span>
                        公司名称
                        <el-tooltip placement="right">
                            <i class="el-icon-question"></i>
                            <div slot="content">
                              公司名称，不能重复。
                            </div>
                        </el-tooltip>
                    </span>
                </template>
                <el-select v-model="createForm.companyId" filterable allow-create placeholder="请填写公司名称" :disabled="disbledCompany" style="width:100%">
                  <el-option
                    v-for="item in companyOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="companyCode">
                <template slot="label">
                    <span>
                        公司代码
                        <el-tooltip placement="right">
                            <i class="el-icon-question"></i>
                            <div slot="content">
                              新添加的公司需要指定公司代码，公司代码会出现在订单中，形式：公司代码-年月日-编号
                            </div>
                        </el-tooltip>
                    </span>
                </template>
                <el-input v-model="createForm.companyCode" placeholder="请填写公司名称" :disabled="disbledCompany" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item label="" prop="parentCompanyId">
                <template slot="label">
                    <span>
                        父级公司名称
                        <el-tooltip placement="right">
                            <i class="el-icon-question"></i>
                            <div slot="content">
                              对于存在上下级关系的公司，可填写上级公司名称。
                            </div>
                        </el-tooltip>
                    </span>
                </template>
                <el-select v-model="createForm.parentCompanyId" filterable allow-create placeholder="请填写公司名称" style="width: 100%;">
                  <el-option
                    v-for="item in companyOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="limit">
                <template slot="label">
                    <span>
                        使用父公司名称
                        <el-tooltip placement="right">
                            <i class="el-icon-question"></i>
                            <div slot="content">
                              打开后，订单中的客户编号及客户名称将使用父公司的信息，订单编号、销售订单号也会与父公司一起编号
                            </div>
                        </el-tooltip>
                    </span>
                </template>
                <el-switch v-model="createForm.useParentInfo"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item prop="payMethod">
                <template slot="label">
                    <span>
                        支付方式
                        <el-tooltip placement="right">
                            <i class="el-icon-question"></i>
                            <div slot="content">
                                货款支付方式<br/>
                                赊销：赊销额度范围呢，可直接下单<br/>
                                预付：预付货款后，才可正式下单
                            </div>
                        </el-tooltip>
                    </span>
                </template>
                <el-select v-model="createForm.payMethod" filterable placeholder="请选择支付方式" style="width:100%">
                  <el-option label="赊销" value="0"/>
                  <el-option label="预付" value="1"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="limit">
                <template slot="label">
                    <span>
                        赊销额度
                        <el-tooltip placement="right">
                            <i class="el-icon-question"></i>
                            <div slot="content">
                                公司的赊销额度
                            </div>
                        </el-tooltip>
                    </span>
                </template>
                <el-input-number controls-position="right" :min="0" :step="1" :precision="2" v-model="createForm.limit" placeholder="请填写赊销额度" style="width: 100%"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="fillDemandMonth">
                <template slot="label">
                    <span>
                        需求所属月份
                        <el-tooltip placement="right">
                            <i class="el-icon-question"></i>
                            <div slot="content">
                              打开后，客户下单时，必须选择当前订单的需求所属月份，提供前月、前月补充、当月、当月补充、次月、次月补充六个选项<br/>
                              例：2023年12月客户下单时，选项显示2023年11月、2023年11月补充、2023年12月、2023年12月补充、2024年1月、2024年1月补充
                            </div>
                        </el-tooltip>
                    </span>
                </template>
                <el-switch v-model="createForm.fillDemandMonth"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <span>注：价格计算方式默认以含税为准，如需调整请前往【权限管理 / 公司管理】调整</span>
            </el-col>
          </el-row>
          <el-divider>
            审核信息
            <el-tooltip placement="right">
              <i class="el-icon-question"></i>
              <div slot="content">
                快速添加仅支持两级，更多层级请使用 审核配置/审核步骤 进行设置
              </div>
            </el-tooltip>
          </el-divider>
          <el-row :gutter="20" v-for="(reviewer, index) in createForm.reviewers" :key="index">
            <el-col :span="8">
              <el-form-item prop="reviewerEmail">
                <template slot="label">
                    <span>
                        {{index+1}}级审核人邮箱
                        <el-tooltip placement="right">
                            <i class="el-icon-question"></i>
                            <div slot="content">
                                {{index+1}}级审核人邮箱，也是登录账号，初始密码为Aa123456
                            </div>
                        </el-tooltip>
                    </span>
                </template>
                <el-input v-model="reviewer.email" :placeholder="`请填写${index+1}级审核人邮箱`" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="reviewerName">
                <template slot="label">
                    <span>
                        {{index+1}}级审核人姓名
                        <el-tooltip placement="right">
                            <i class="el-icon-question"></i>
                            <div slot="content">
                                {{index+1}}级审核人姓名
                            </div>
                        </el-tooltip>
                    </span>
                </template>
                <el-input v-model="reviewer.name" :placeholder="`请填写${index+1}级审核人姓名`" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="reviewerMobile1">
                <template slot="label">
                    <span>
                        {{index+1}}级审核人手机
                        <el-tooltip placement="right">
                            <i class="el-icon-question"></i>
                            <div slot="content">
                                {{index+1}}级审核人手机
                            </div>
                        </el-tooltip>
                    </span>
                </template>
                <el-input v-model="reviewer.mobile" :placeholder="`请填写${index+1}级审核人手机号`" clearable/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider>
            部门
            <el-tooltip placement="right">
              <i class="el-icon-question"></i>
              <div slot="content">
                快速添加仅支持添加五个部门，更多设置请使用 人事管理/组织机构管理 进行设置
              </div>
            </el-tooltip>
          </el-divider>
          <el-row :gutter="20" v-for="(department, index) in createForm.departments" :key="index">
            <el-col :span="24">
              <el-form-item prop="department">
                <template slot="label">
                    <span>
                        部门名称
                        <el-tooltip placement="right">
                            <i class="el-icon-question"></i>
                            <div slot="content">
                                部门名称
                            </div>
                        </el-tooltip>
                    </span>
                </template>
                <el-input v-model="department.name" placeholder="请填写部门名称" clearable/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="createDialogVisible = false" size="mini" :loading="editLoading">取 消</el-button>
          <el-button type="primary" @click="onSubmit" size="mini" :loading="editLoading">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="编辑VIP客户公司" :visible.sync="editDialogVisible" width="600px" :close-on-click-modal="false">
        <el-form ref="editForm" :model="editForm" :rules="rules" size="mini" label-width="130px">
          <el-form-item prop="companyName">
            <template slot="label">
              <span>
                  公司名称
                  <el-tooltip placement="right">
                      <i class="el-icon-question"></i>
                      <div slot="content">
                        公司名称，不能重复。
                      </div>
                  </el-tooltip>
              </span>
            </template>
            <el-input v-model="editForm.companyName" placeholder="请输入公司名称" disabled clearable></el-input>
          </el-form-item>
          <el-form-item prop="payMethod">
            <template slot="label">
                <span>
                    支付方式
                    <el-tooltip placement="right">
                        <i class="el-icon-question"></i>
                        <div slot="content">
                            货款支付方式<br/>
                            赊销：赊销额度范围呢，可直接下单<br/>
                            预付：预付货款后，才可正式下单
                        </div>
                    </el-tooltip>
                </span>
            </template>
            <el-select v-model="editForm.payMethod" filterable placeholder="请选择支付方式" style="width:100%">
              <el-option label="赊销" :value="0"/>
              <el-option label="预付" :value="1"/>
            </el-select>
          </el-form-item>
          <el-form-item prop="fillDemandMonth">
            <template slot="label">
              <span>
                  需求所属月份
                  <el-tooltip placement="right">
                      <i class="el-icon-question"></i>
                      <div slot="content">
                        打开后，客户下单时，必须选择当前订单的需求所属月份，提供前月、前月补充、当月、当月补充、次月、次月补充六个选项<br/>
                        例：2023年12月客户下单时，选项显示2023年11月、2023年11月补充、2023年12月、2023年12月补充、2024年1月、2024年1月补充
                      </div>
                  </el-tooltip>
              </span>
            </template>
            <el-switch v-model="editForm.fillDemandMonth"></el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false" size="mini" :loading="editLoading">取 消</el-button>
          <el-button type="primary" @click="onSubmitEdit" size="mini" :loading="editLoading">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  <script>
  const HEIGHT_OFFSET = 118;
  export default {
    data() {
      return {
        pageLoading: undefined,
        tableConfig: {
              height: 0,
        },
        loading: false,
        editLoading: false,
        total: 0,
        pageSize: 10,
        currentPage: 1,
        tableData: [],
        createDialogVisible: false,
        editDialogVisible: false,
        searchForm: {
          companyName: "",
        },
        companyOptions: [],
        disbledCompany: false,
        createForm: {
          id: "",
          companyId: "",
          parentCompanyId: "",
          useParentInfo: false,
          fillDemandMonth: false,
          payMethod: "",
          limit: 0,
          distribution: false,
          internalReview: false,
          valid: true,
          reviewers: [
            {email: "", name: "", mobile: ""},
            {email: "", name: "", mobile: ""},
          ],
          departments: [
            {name: "", limit: 0},
            {name: "", limit: 0},
            {name: "", limit: 0},
            {name: "", limit: 0},
            {name: "", limit: 0},
          ],
        },
        editForm: {
          id: "",
          companyId: "",
          companyName: "",
          fillDemandMonth: false,
          payMethod: "",
        },
        rules: {
          companyId: [
            { required: true, message: '请输入公司代码', trigger: 'blur' }
          ],
          payMethod: [
            { required: true, message: '请选择支付方式', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      onSearch() {
        this.loading = true;
        let that = this
        let param = {};
        if(this.searchForm.companyName) {
          param.companyName = this.searchForm.companyName;
        }
        this.$axios.post("/admin/customer/searchCompany",{
            cond: param,
            page: this.currentPage - 1,size:this.pageSize
        }).then(function(response) {
            let resp = response.data;
            if(resp.header.status == 0) {
              that.loading = false;
              that.tableData = resp.data.content;
              that.total = resp.data.totalElements;
            }
        }).catch(function() {
          that.loading = false;
        });
      },
      handleSizeChange(pageSize){
          this.pageSize = pageSize;
          this.onSearch();
      },
      onPageChange(currentPage) {
        this.currentPage = currentPage;
        this.onSearch();
      },
      showCreateDialog() {
        let that = this;
        that.editLoading = true;
        that.createDialogVisible = true;
        this.$axios.post("/admin/company/list",{})
        .then(function(response) {
          let resp = response.data;
          if(resp.header.status == 0) {
            that.companyOptions = resp.data;
            that.createForm = {
              id: "",
              companyId: "",
              parentCompanyId: "",
              useParentInfo: false,
              payMethod: "",
              limit: 0,
              distribution: false,
              internalReview: false,
              valid: true,
              reviewers: [
                {email: "", name: "", mobile: ""},
                {email: "", name: "", mobile: ""},
              ],
              departments: [
                {name: ""},
                {name: ""},
                {name: ""},
                {name: ""},
                {name: ""},
              ],
            };
            that.disbledCompany = false;
          }
        }).finally(() => {
          that.editLoading = false;
        });
      },
      handleEdit(row) {
        let that = this;
        that.editId = row['id'];
        that.editDialogVisible = true;
        this.$axios.get("/admin/customer/"+that.editId)
        .then(function(response) {
          let resp = response.data;
          if(resp.header.status == 0) {
            that.editForm = resp.data;
          }
        });
      },
      onSubmit() {
        let that = this;
        that.editLoading = true;
        this.$refs.createForm.validate(valid => {
          if (valid) {
            let param = {...this.createForm, distribution: this.createForm.distribution ? 1 : 0}
            this.$axios.post("/admin/customer/saveCompany", param)
            .then(function(response) {
              let resp = response.data;
              if(resp.header.status == 0) {
                that.onSearch();
                that.createDialogVisible = false;
              } else {
                that.$notify.error({
                    title: '错误',
                    message: resp.header.msg
                });
              }
            }).finally(() => {
              that.editLoading = false;
            });
          } else {
              that.editLoading = false;
          }
        });
      },
      onSubmitEdit() {
        let that = this;
        that.editLoading = true;
        this.$refs.editForm.validate(valid => {
          if (valid) {
            this.$axios.post("/admin/customer/editCompany", that.editForm)
            .then(function(response) {
              let resp = response.data;
              if(resp.header.status == 0) {
                that.onSearch();
                that.editDialogVisible = false;
              } else {
                that.$notify.error({
                    title: '错误',
                    message: resp.header.msg
                });
              }
            }).finally(() => {
              that.editLoading = false;
            });
          }
        });
      },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }
    },
    created() {
        this.onSearch();
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
          this.pageLoading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
          });
          setTimeout(() => {
              this.setTableHeight();
              this.pageLoading.close();
              this.pageLoading = undefined;
          }, 500);
      },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }

    },
    destroyed () {
          window.removeEventListener("resize", this.setTableHeight);
    }
  }
  </script>